import { createTheme } from '@mui/material';
import { generalTheme } from './general_theme';

export const checkBoxTheme = createTheme(generalTheme, {
  components: {
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#e69636',
          '&.Mui-checked': {
            color: '#277134',
          },
          '&.Mui-disabled': {
            opacity: 0.5,
          },
        },
      },
    },
  },
});
